'use strict';
import util from '../util';
import pdfUtils from '../pdfUtils';
import ajax from '../ajax';

//Creating instance of PDFDocument Class using HTMLtoPDF library - npm package
var initOrderHistory = function() {
    $('a.download-invoice').on('click', downloadInvoice);
    //Disabling Right Click on Download Invoice Link
    $('a.download-invoice').on('contextmenu',function(e){
        return false;
    });
	
    $('a.prepaid-label').on('click', downloadPrepaidLabel);
    $('a.prepaid-dhl-label').on('click', downloadRoyalmailPrepaidLabel);
	
}

/*
 * Download Prepaid label
 */
function downloadPrepaidLabel(e) {
	    e.preventDefault();
	   
	    var $this = $(this);
	    var filename = $(this).attr('download');
	    $(this).attr('disabled', 'disabled');
	        var that = this;
	        var perpaidURL = $(this).data('prepaid-url');
	        
	        ajax.getJson({
	            url : perpaidURL,
	            callback: function(response) {
	                $this.parents('.print-slips-block').find('#prepaid-msg').text(response.msg);
	                $this.removeAttr('disabled');
	            }
	        });    
	    
}
	
/*
	 * Download Royalmail Prepaid label
	 */
function downloadRoyalmailPrepaidLabel(e) {
    e.preventDefault();
    var pdfEncodedData = $(this).data('pdf-encoded');
    var $this = $(this);
    var filename = $(this).attr('download');
    $(this).attr('disabled', 'disabled');
		
    if(pdfEncodedData == '') {
        var that = this;
        var perpaidURL = $(this).data('prepaid-url');

        ajax.getJson({
            url : perpaidURL,
            callback: function(response) {
                if (!response || response.outputImage == '') {
                    $(that).removeAttr('disabled');
                    $this.parents('.print-slips-block').find('#prepaid-msg').text(response.msg);
		                $this.removeAttr('disabled');
                    return false;
                }
                pdfEncodedData = response.outputImage;
                getPrepaidLabelPDF(pdfEncodedData, filename, that);
					
                $(that).data('pdf-encoded', pdfEncodedData);
            }
        });
    } else {
        getPrepaidLabelPDF(pdfEncodedData, filename, this);
    }
}
	
function getPrepaidLabelPDF(pdfEncodedData, filename, clickEle) {
    var blob = getBlob(pdfEncodedData);
		
    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(blob, filename);
    } else {
        var link = document.createElementNS('http://www.w3.org/1999/xhtml', 'a');
        link.href = URL.createObjectURL(blob);
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }
		
    $(clickEle).removeAttr('disabled');
}

function getBlob(base64Data){
    var byteCharacters = atob(base64Data);
    var byteNumbers = new Array(byteCharacters.length);
    for (var i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    var byteArray = new Uint8Array(byteNumbers);
    return new Blob([byteArray], {type: 'application/pdf;charset=utf-8'});
}
	
/*
 * Download Invoice
 */
function downloadInvoice(e) {
    e.preventDefault();

    var invoiceURL = $(this).attr('href');

    $.ajax({
        url : invoiceURL,
        type : 'GET'
    }).then(function(response){
        var doc = new jsPDF('l', 'pt', 'a4');
        var invoiceNumber = $(response).find('#invoice-number-pdf');
        var invoiceAddress = $(response).find('#invoice-address-pdf');
        var orderNumber = $(response).find('#page-intro-pdf');
        var orderDate = $(response).find('#order-date-pdf');
        var invoiceDate = $(response).find('#invoice-date-pdf');
        var invoiceEmeaTaxNumber = $(response).find('#invoice-emea-tax-number-pdf');
        var invoiceSubsidiaryInformation = $(response).find('#invoice-subsidiary-information-pdf address');
        var invoiceBottomInformation = $(response).find('#invoice-bottom-information-pdf');
        var cardImageEle = $(response).find('.payment-block .logo').get(0);		
        var idInfo = $(response).find('.id-documents');
		
        //Order Table Data Push
        var orderTableColumn = new Array();
        $(response).find('.address-method-payment-table-column').each(function() {
            orderTableColumn.push($(this).text().trim().replace(/\s+/g, ' '));
        });
        orderTableColumn.push('');
		
        var orderTableRows = new Array();
        var orderTableRow = new Array();
        var i = 0;
        $(response).find('.address-method-payment-table-row').each(function() {
            if(cardImageEle != null && i == 3) {
                orderTableRow.push('');
            }
            orderTableRow.push($(this).text().trim());
            i++;
        });

        orderTableRows.push(orderTableRow);
		
        //Product Table Data Push
        var productTableColumn = new Array();
        $(response).find('.table-header span').each(function() {
            productTableColumn.push($(this).text().trim().replace(/\s+/g, ' '));
        });

        var productTableRows = new Array();

        $(response).find('.table-rows').each(function() {
            var productTableRow = new Array();
            $(this).find('span').each(function() {
                productTableRow.push($(this).text().trim().replace(/\s+/g, ' '));
            });
			
            productTableRows.push(productTableRow);
        });

        //Order Total Data Push
        var orderTotalsColumns = ['', ''];
        var orderTotalsRows = new Array();
		
        $(response).find('.calculations-container div.clearfix').each(function() {
            var orderTotalsRow = new Array();
            var line1 = $(this).find('.order-label-pdf').text().trim().replace(/\s+/g, ' ');
            var line2 = $(this).find('.order-value-pdf').text().trim().replace(/\s+/g, ' ');
			
            orderTotalsRow.push(line1);
            orderTotalsRow.push(line2);
			
            orderTotalsRows.push(orderTotalsRow);
        });

        var emeaLogoEle = $(response).find('.pdf-emea-logo').get(0);
		
        var pdfInvoiceNumberText = pdfUtils.getElementHtmlTrim(invoiceNumber);
        var pdfInvoiceAddressText = pdfUtils.getElementHtmlTrim(invoiceAddress);
        var pdfOrderNumberText = pdfUtils.getElementHtmlTrim(orderNumber);
        var pdfOrderDateText = pdfUtils.getElementHtmlTrim(orderDate);
        var pdfInvoiceDateText = pdfUtils.getElementHtmlTrim(invoiceDate);
        var pdfInvoiceEmeaTaxNumber = pdfUtils.getElementHtmlTrim(invoiceEmeaTaxNumber);
        var pdfInvoiceSubsidiaryInformation = pdfUtils.getElementHtmlTrim(invoiceSubsidiaryInformation);
        var pdfInvoiceBottomInformation = pdfUtils.getElementHtmlTrim(invoiceBottomInformation);
        var idDocuments = pdfUtils.getElementHtmlTrim(idInfo);
		
        //emea tax invoice info
        var emeaTaxCol = [''],
            taxInfo1 = [invoiceEmeaTaxNumber.text().trim().replace(/\s+/g, ' ')],
            taxInfo2 = [invoiceSubsidiaryInformation.html().trim().replace(/\s+/g, ' ')],
            subSidiaryStr = invoiceSubsidiaryInformation.html().split('<br>'),
            emeaTaxRows	= [];
        $.each(subSidiaryStr, function(index, value){
            var subSidiaryAdd = [];
            subSidiaryAdd.push(value.replace(/\s+/g, ' '));
            emeaTaxRows.push(subSidiaryAdd);
        })
			
        var imgData, pdfcardImageBase64;
			
        if (cardImageEle) {
            //banking image
            toDataUrl(cardImageEle.src, function(pdfcardImageBase64) {		
                if(pdfcardImageBase64.indexOf('text') != '-1'){
                    pdfcardImageBase64 = loadDefault();
                }else{
                    resize(pdfcardImageBase64, function(result){
                        pdfcardImageBase64 = result;
                    });
                }
				
                //logo image
                toDataUrl(emeaLogoEle.src, function(imgData) {		
                    if(imgData.indexOf('text') != '-1'){
                        imgData = loadDefault();
                    }
					
					 generateInvoicePDF(doc, imgData, pdfInvoiceNumberText, pdfInvoiceAddressText, pdfcardImageBase64, 
				 				pdfOrderNumberText, pdfOrderDateText, pdfInvoiceDateText, pdfInvoiceEmeaTaxNumber,
				 				pdfInvoiceSubsidiaryInformation, pdfInvoiceBottomInformation, orderTableColumn, orderTableRows, productTableColumn, productTableRows, 
				 				orderTotalsColumns, orderTotalsRows, emeaTaxCol, emeaTaxRows, idDocuments);
                });
            });
        } else {
            //logo image
            toDataUrl(emeaLogoEle.src, function(imgData) {		
                if(imgData.indexOf('text') != '-1'){
                    imgData = loadDefault();
                }
					
					 generateInvoicePDF(doc, imgData, pdfInvoiceNumberText, pdfInvoiceAddressText, null, 
				 				pdfOrderNumberText, pdfOrderDateText, pdfInvoiceDateText, pdfInvoiceEmeaTaxNumber,
				 				pdfInvoiceSubsidiaryInformation, pdfInvoiceBottomInformation, orderTableColumn, orderTableRows, productTableColumn, productTableRows, 
				 				orderTotalsColumns, orderTotalsRows, emeaTaxCol, emeaTaxRows, idDocuments);
            });
        }
    });
}
/**
 * 
 * @desc image to base 64
 */
function toDataUrl(url, callback) {
    var xhr = new XMLHttpRequest();
    xhr.onload = function() {
        var reader = new FileReader();
        reader.onloadend   = function() {        	 
            callback(reader.result);
        }
        
        reader.readAsDataURL(xhr.response);
        
    };
    xhr.open('GET', url);
    xhr.responseType = 'blob';
    xhr.send();
}

/*
 * resize image
 */
function resize(imgData, callback) {
    var width = 65;
    var height = 41;  
    var img = document.createElement('img');
    
    img.onload = function() {        
        // We create a canvas and get its context.
        var canvas = document.createElement('canvas');
        var ctx = canvas.getContext('2d');

        // We set the dimensions at the wanted size.
        canvas.width = width;
        canvas.height = height;

        // We resize the image with the canvas method drawImage();
        ctx.drawImage(this, 0, 0, width, height);

        var dataURI = canvas.toDataURL();
        callback(dataURI);

    };
    img.src = imgData;
    
}

/*
 * Load default data
 */
function loadDefault(){
    return 'data:image/png;base64,/9j/4AAQSkZJRgABAQEAYABgAAD/2wBDAAIBAQIBAQICAgICAgICAwUDAwMDAwYEBAMFBwYHBwcGBwcICQsJCAgKCAcHCg0KCgsMDAwMBwkODw0MDgsMDAz/2wBDAQICAgMDAwYDAwYMCAcIDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAz/wAARCAABAAEDASIAAhEBAxEB/8QAHwAAAQUBAQEBAQEAAAAAAAAAAAECAwQFBgcICQoL/8QAtRAAAgEDAwIEAwUFBAQAAAF9AQIDAAQRBRIhMUEGE1FhByJxFDKBkaEII0KxwRVS0fAkM2JyggkKFhcYGRolJicoKSo0NTY3ODk6Q0RFRkdISUpTVFVWV1hZWmNkZWZnaGlqc3R1dnd4eXqDhIWGh4iJipKTlJWWl5iZmqKjpKWmp6ipqrKztLW2t7i5usLDxMXGx8jJytLT1NXW19jZ2uHi4+Tl5ufo6erx8vP09fb3+Pn6/8QAHwEAAwEBAQEBAQEBAQAAAAAAAAECAwQFBgcICQoL/8QAtREAAgECBAQDBAcFBAQAAQJ3AAECAxEEBSExBhJBUQdhcRMiMoEIFEKRobHBCSMzUvAVYnLRChYkNOEl8RcYGRomJygpKjU2Nzg5OkNERUZHSElKU1RVVldYWVpjZGVmZ2hpanN0dXZ3eHl6goOEhYaHiImKkpOUlZaXmJmaoqOkpaanqKmqsrO0tba3uLm6wsPExcbHyMnK0tPU1dbX2Nna4uPk5ebn6Onq8vP09fb3+Pn6/9oADAMBAAIRAxEAPwD9/KKKKAP/2Q==';
}

function getBase64Image(img) {
    var canvas = document.createElement('canvas');
    canvas.width = img.width;
    canvas.height = img.height;
    var ctx = canvas.getContext('2d');
    ctx.drawImage(img, 0, 0);
    var dataURL = canvas.toDataURL('image/png');
	 var base64 = dataURL.replace(/^data:image\/(png|jpg);base64,/, '');
	 
	 return base64;
}

function generateInvoicePDF(doc, imgData, pdfInvoiceNumberText, pdfInvoiceAddressText, pdfcardImageBase64, 
    pdfOrderNumberText, pdfOrderDateText, pdfInvoiceDateText, pdfInvoiceEmeaTaxNumber,
    pdfInvoiceSubsidiaryInformation, pdfInvoiceBottomInformation, orderTableColumn, orderTableRows, productTableColumn, productTableRows, 
    orderTotalsColumns, orderTotalsRows, emeaTaxCol, emeaTaxRows, idDocuments) {

    doc.page=1;
    //Logo and Invoice Number
    doc.addImage(imgData, 'PNG', 18, 20, 182, 48);
    doc.fromHTML(pdfInvoiceNumberText, 20, 100);
    doc.fromHTML(idDocuments, 20, 75);

    //Invoice Address
    var addHtml = $.parseHTML(pdfInvoiceAddressText)[0].innerHTML,
        addLeftPos = 620, 
        htmlArray = addHtml.split('<br>');
	
    $.each(htmlArray, function(i, j){
        if(j.length > 35)
            addLeftPos = 490;
    })
	
    doc.fromHTML(pdfInvoiceAddressText, addLeftPos, 20);

    if (pdfcardImageBase64) {
        //Payment Text, Image and Value
        doc.addImage(pdfcardImageBase64, 'PNG', 475, 185, 48.75, 30.75);
    }

    //Order Number, Order Date, Invoice Date
    doc.fromHTML(pdfOrderNumberText, 25, 285);
    doc.fromHTML(pdfOrderDateText, 195, 285);
    doc.fromHTML(pdfInvoiceDateText, 350, 285);

    //Table - Product, Unit Price, Quantity, Total Price
    doc.autoTable(orderTableColumn, orderTableRows, {theme: 'plain',
        styles:{cellPadding: 5, overflow: 'linebreak'},
        columnStyles: {
            0: {columnWidth: 150},
            1: {columnWidth: 150},
            2: {columnWidth: 150},
            3: {columnWidth: pdfcardImageBase64 ? 100 : 150},
            4: {columnWidth: 150}
        },
        startY: false,
        margin: {top: 155, left: 20}
    });

    //Order Total table
    doc.autoTable(orderTotalsColumns, orderTotalsRows, {theme: 'plain', 
        columnStyles:{
            0: {columnWidth: 130, halign: 'left'},
            1: {columnWidth: 70, halign: 'right'}
        },
        styles:{columnWidth: 150, overflow: 'linebreak'}, 
        margin: {top: 325, left: 630},
        createdCell: function(cell, data) {
            if (data.row.index === 3) { 
                cell.styles.fontStyle = 'bold';
            }
        }
    });

    var totalPages = 1;

    if(productTableRows.length > 6) {
        totalPages = 2;
    }

    doc.setFontSize(8);
    doc.text(400, 580, Resources.INVOICE_PAGE + doc.page + ' '+ Resources.INVOICE_OF +' '+  totalPages);
    doc.page ++;

    //Product list table
    doc.autoTable(productTableColumn, productTableRows, {theme: 'striped', 
        columnStyles: {
            0: {columnWidth: 230, halign:'left'},
            1: {columnWidth: 75},
            2: {columnWidth: 75},
            3: {columnWidth: 75},
            4: {columnWidth: 75},
            5: {columnWidth: 75}
        },
        styles:{
            halign: 'center',
            overflow: 'linebreak'
        },
        headerStyles:{
            halign: 'center',
            fillColor: [0, 0, 0],
            textColor: [255, 255, 255]
        },
        startY: 350,
        margin: {top: 20, left: 20, bottom: 80}
    });

    if(productTableRows.length > 6) {
        doc.text(400, 580, Resources.INVOICE_PAGE + doc.page + ' '+ Resources.INVOICE_OF +' '+ totalPages);
    }

    //EMEA Tax Number, Name, Group Address
    //	doc.autoTable.previous.finalY;
    //	doc.fromHTML(pdfInvoiceEmeaTaxNumber, 630, 550);
	
    doc.fromHTML(pdfInvoiceBottomInformation, 20, 455);
	
    //EMEA Tax Number, Name, Group Address table
	
    doc.autoTable(emeaTaxCol, emeaTaxRows, {theme: 'plain', 
        columnStyles: {
            0: {halign: 'center'}
        },
        tableWidth: 'auto',
        showHeader: '',
        headerStyles: {
            halign: 'center'
        },
        styles:{
            overflow: 'linebreak',
            cellPadding: 1,
            fontSize: 10
        },
        startY: 528,
        margin: {top: 30, left: 20}
    });
	
	
    //pdf generation and file creation
    doc.save(Resources.DOWNLOAD_INVOICE_FILENAME);
}

export default {
    init: function () {
        initOrderHistory();
    }
};